import type { TFunction } from 'i18next';
import { z } from 'zod';

/**
 * `src/i18n.ts` now registers a global zod error map (`src/utils/zodErrorMap.ts`), so zod's
 * own messages are localised everywhere. These schemas keep threading `t` themselves
 * because they want messages the generic map cannot produce — "use at least 3 characters"
 * for a slug, "lowercase letters, numbers and hyphens only" for its format — rather than
 * the generic minLength/pattern wording.
 */
const SLUG = /^[a-z0-9-]+$/;

export const profileSchema = (t: TFunction) =>
  z.object({
    firstName: z.string().trim().min(1, t('onboarding.validation.required')).max(60),
    lastName: z.string().trim().min(1, t('onboarding.validation.required')).max(60),
  });

export const organizationSchema = (t: TFunction) =>
  z.object({
    name: z.string().trim().min(2, t('onboarding.validation.nameTooShort')).max(60),
    slug: z
      .string()
      .trim()
      .min(3, t('onboarding.validation.slugTooShort'))
      .max(32)
      .regex(SLUG, t('onboarding.validation.slugFormat')),
  });

const place = (t: TFunction) =>
  z.object({
    name: z.string().trim().min(2, t('onboarding.validation.nameTooShort')).max(60),
    // A blank address is accepted by the generated DTO but rejected by the API with a 422.
    address: z.string().trim().min(1, t('onboarding.validation.required')).max(255),
  });

export const restaurantSchema = place;
export const branchSchema = place;

export const inviteSchema = (t: TFunction) =>
  z.object({
    rows: z.array(
      z.object({
        // A blank row is how the user leaves the wizard without inviting anyone.
        email: z.union([z.literal(''), z.string().email(t('onboarding.validation.emailInvalid'))]),
        role: z.enum(['admin', 'member']),
      })
    ),
  });
